import { render } from "./add-target.vue?vue&type=template&id=74200d7c"
import script from "./add-target.vue?vue&type=script&lang=js"
export * from "./add-target.vue?vue&type=script&lang=js"
script.render = render

export default script